import { Component } from '@angular/core';
import { ErrorLike, isNotNullOrUndefined, isNullOrUndefined, SerializedData } from 'in-time-core';
import { DialogService } from '../dynamic-dialog/dialog.service';
import { DynamicDialogConfig } from '../dynamic-dialog/dynamic-dialog-config';
import { DynamicDialogRef } from '../dynamic-dialog/dynamic-dialog-ref';
import { TranslocoModule } from '@ngneat/transloco';

export function showErrorDialog(
  dialogService: DialogService,
  error: ErrorLike | null,
  args?: SerializedData,
  test?: (err: ErrorLike) => boolean
) {
  if(isNullOrUndefined(error) || (isNotNullOrUndefined(test) && !test(error))) {
    return;
  }

  dialogService.open(ErrorDialogComponent, {
    data: { 'error': error.toString(), 'args': args }
  });
}

@Component({
  standalone: true,
  imports: [ TranslocoModule ],
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss']
})
export class ErrorDialogComponent {
  readonly localizationString: string;
  readonly errorCode: string;
  readonly errorParams: SerializedData | undefined;

  constructor(
		public config: DynamicDialogConfig,
		private dialogRef: DynamicDialogRef,
  ) {
    const rawErrorCode = config.data.error as string;
    const args = config.data.args as SerializedData | null | undefined;

    this.errorParams = args ?? undefined;
    this.errorCode = rawErrorCode.split('/')[1];
    this.localizationString = rawErrorCode.replace('/', '.');
  }

  close(): void {
    this.dialogRef.close();
  }

  formatError(translation: string): string {
    if(translation == null || translation.length <= 0) {
      return this.errorCode;
    }
    else if(translation[translation.length - 1] == '.') {
      if(this.errorCode == null || this.errorCode.length <= 0) {
        return translation;
      }

      return `${translation} (${this.errorCode})`;
    }

    if(this.errorCode == null || this.errorCode.length <= 0) {
      return translation;
    }

    return `${translation}. (${this.errorCode})`;
  }
}
